import { render, staticRenderFns } from "./FaqsCallOutCharge.vue?vue&type=template&id=01934096&scoped=true"
import script from "./FaqsCallOutCharge.vue?vue&type=script&lang=js"
export * from "./FaqsCallOutCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01934096",
  null
  
)

export default component.exports